import React, { Suspense } from 'react'
import { Flex, Text } from 'pcln-design-system'
import { LoaderDots } from '@pcln/fly-ui-components'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import { setCurrentMobileFilter } from '../../reducers/uiToggles'
import { navigateToListingsPage } from '../../util/routingHelper'

const LazyFilters = React.lazy(() => import(/* webpackPrefetch: true */ '../FilterBar/FilterOverlay'))

const Fallback = () => (
  <Flex flexDirection={'column'} justifyContent={'center'} mt={2}>
    <Text color={'primary.base'} textAlign={'center'}>
      Loading Filters
    </Text>
    <LoaderDots />
  </Flex>
)

const LazyFilterOverlay = () => {
  const history = useHistory()
  const dispatch = useDispatch()

  function handleClose() {
    dispatch(setCurrentMobileFilter(''))
    navigateToListingsPage(history)
  }

  return (
    <Suspense fallback={<Fallback />}>
      <LazyFilters onClose={handleClose} />
    </Suspense>
  )
}

export { LazyFilterOverlay as default } // lazy loaded, keeping default
